<shell-layout [error_identity]="true">
  <img class="m-auto" src=" assets/img/errors/error__questions.svg" alt="Error" />

  <ui-text color="blue-500" size="h4" weight="semibold" align="center" class="mt-6">
    ¡No logramos validar tus respuestas!
  </ui-text>

  <ui-text color="blue-300" align="center" class="mt-3">
    Debes responderlas correctamente
  </ui-text>

  <div class="flex mt-10">
    <ui-button
      (clicked)="closeModal()"
      class="m-auto"
      type="primary"
      label="Reintentar ahora"
    ></ui-button>
  </div>
</shell-layout>
